<template>
  <v-card elevation="0" color="grey lighten-4" class="mb-8">
    <v-card-text class="pb-0">
      <v-row>
        <v-col>
          <v-menu
            ref="datepicker"
            :close-on-content-click="false"
            v-model="datepicker"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :rules="[validDate]"
                v-model="departureDate"
                label="Tjänstedatum"
                readonly
                outlined
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              locale="sv"
              first-day-of-week="1"
              v-model="departureDate"
              no-title
              @input="datepicker = false"
            />
          </v-menu>
        </v-col>
        <v-col>
          <v-text-field
            label="Tågnummer"
            outlined
            type="number"
            @keydown.enter.stop.prevent="onSearchTrain"
            v-model.number="model.train_number"
            :rules="[required]"
          />
        </v-col>
        <v-col cols="auto">
          <v-btn
            x-large
            :loading="$apollo.loading"
            color="grey lighten-2"
            @click="onSearchTrain"
          >
            <v-icon>mdi-magnify</v-icon> Sök
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import { validDate } from '@/common/validationRules'
import { format } from 'date-fns'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import gql from 'graphql-tag'

export default {
  name: 'CrewActivitySearch',

  data: () => ({
    validDate,
    required,
    datepicker: false,
    departureDate: format(new Date(), 'yyyy-MM-dd')
  }),

  computed: {
    model: sync('crew/model')
  },

  apollo: {
    searchTrain: {
      query: gql`
        query searchTrain($filter: SearchTrainInput!) {
          searchTrain(filter: $filter) {
            public_number
            places {
              type
              location
              location_long_name
              advertised
              delay_minutes
            }
          }
        }
      `,
      skip: true,
      variables() {
        return {
          filter: {
            train_number: this.model.train_number || null,
            date: this.departureDate
          }
        }
      }
    }
  },

  methods: {
    onSearchTrain() {
      this.$apollo.queries.searchTrain.skip = false
    }
  },

  watch: {
    departureDate() {
      this.$store.set('crew/model@duty_date', this.departureDate)
      this.onSearchTrain()
    },
    searchTrain: {
      handler(value) {
        if (this.$apollo.queries.searchTrain) {
          this.$apollo.queries.searchTrain.skip = true
        }
        if (!value) {
          this.$store.set('crew/places', [])
          return
        }
        this.$store.set('crew/places', value.places)
        this.$store.set('crew/model@from', value.places[0].location)
        this.$store.set(
          'crew/model@to',
          value.places[value.places.length - 1].location
        )
      }
    }
  }
}
</script>
